import React from "react";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { SwitcherSheet } from "./SwitcherSheet";
import { Store } from "../../../../shared/types/store";
import { StoreEnvironmentSelector } from "./StoreEnvironmentSelector";
import { useTranslation } from "@coworker/locales";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import LinkOutIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import InformationCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import { MY_IDENTITY_STORE_REQUEST_URL } from "@coworker/consts/myIdentityLinks";

interface SwitchStoreSheetProps {
  stores: Store[] | undefined;
  selectedStore: Store | undefined;
  setSelectedStore: React.Dispatch<React.SetStateAction<Store | undefined>>;
  setSelectedTeam: React.Dispatch<React.SetStateAction<StoreTeam | undefined>>;
  loading: boolean;
  showMissingStoreInfo?: boolean;
}

export const SwitchStoreSheet = (props: SwitchStoreSheetProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const missingStoreInfoNode = props.showMissingStoreInfo ? (
    <FixaInlineMessage
      variant="informative"
      ssrIcon={InformationCircleIconPath}
      title={t("missingStoreString")}
      body={t("missingStoreBodyString")}
      actions={[
        {
          text: t("myIdentityString"),
          type: "tertiary",
          ssrIcon: LinkOutIconPath,
          iconPosition: "trailing",
          onClick: () =>
            window.open(
              MY_IDENTITY_STORE_REQUEST_URL,
              "_blank",
              "noopener,noreferrer"
            ),
        },
      ]}
    />
  ) : undefined;

  return (
    <>
      <StoreEnvironmentSelector
        id="store"
        value={
          !props.selectedStore?.name
            ? t("chooseAnOptionString")
            : `${props.selectedStore.storeId} - ${props.selectedStore.name}`
        }
        label="adminStoreFilter"
        validationMsg="pleaseSelectAStoreString"
        selectedItem={props.selectedStore}
        loading={props.loading}
        onClick={() => {
          setIsOpen(true);
        }}
      />
      <SwitcherSheet
        titleKey="adminStoreFilter"
        placeholderKey="searchStoreString"
        items={props.stores ?? []}
        selectedItem={props.selectedStore}
        getItemLabel={(store) => `${store?.storeId} - ${store?.name}`}
        getItemKey={(store) => store?.storeId ?? ""}
        onSelect={(store) => {
          props.setSelectedStore(store);
          props.setSelectedTeam({} as StoreTeam);
        }}
        loading={props.loading}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        infoNode={missingStoreInfoNode}
      />
    </>
  );
};
